/**
 * Created by yangxx on 2016/12/13.
 */
'use strict';
define([], function() {
    /**
     * 浏览器支持
     */
    (function() {
        //浏览器支持
        if (typeof String.prototype.endsWith != 'function') {
            String.prototype.endsWith = function(suffix) {
                return this.indexOf(suffix, this.length - suffix.length) !== -1;
            }
        }
        if (typeof String.prototype.startsWith != 'function') {
            String.prototype.startsWith = function(prefix) {
                return this.slice(0, prefix.length) === prefix;
            }
        }
    })();
    /**
     * @namespace
     * @description 通用基础工具类，包括ajax请求、对象判断等
     * @alias G.utils.CommonUtil
     */
    var util = {};

    /**
     * 显隐进度条
     * @ignore
     * @method
     * @private
     * @param flag {boolean} - true显示进度条，false隐藏进度条
     */
    util._showLoading = function(flag) {}

    /**
     * 是否是函数
     * @alias isFunction
     * @memberof G.utils.CommonUtil
     * @param obj {Object} - 必填，需要判断的参数
     * @returns {boolean} - 是函数返回true，不是函数返回false
     */
    util.isFunction = function(obj) {
        return (Object.prototype.toString.call(obj) === '[object Function]');
    }

    /**
     * 是否是数组
     * @alias isArray
     * @memberof G.utils.CommonUtil
     * @param obj {Object} - 必填，需要判断的参数
     * @returns {boolean} - 是数组返回true,不是数组返回False
     */
    util.isArray = function(obj) {
        return (Object.prototype.toString.call(obj) === '[object Array]');
    }

    /**
     * 是否是对象
     * @alias isObject
     * @memberof G.utils.CommonUtil
     * @param obj {*} - 必填，需要判断的参数
     * @returns {boolean} - 是对象返回true,不是对象返回false
     */
    util.isObject = function(obj) {
        return (Object.prototype.toString.call(obj) === '[object Object]');
    }

    /**
     * 是否是字符串
     * @alias isString
     * @memberof G.utils.CommonUtil
     * @param obj {*} - 必填，需要判断的参数
     * @returns {boolean} - 是对象返回true,不是对象返回false
     */
    util.isString = function(str) {
        return (Object.prototype.toString.call(str) === '[object String]');
    }

    /**
     * 是否是空对象
     * @alias isEmptyObject
     * @memberof G.utils.CommonUtil
     * @param obj {*} - 必填，需要判断的参数
     * @returns {boolean} - 是空对象返回true,不是空对象返回false
     * */
    util.isEmptyObject = function(obj) {
        for (var t in obj)
            return !1;
        return !0
    }

    /**
     * ajax get请求
     * @ignore
     * @method
     * @param options {Object} - 必填，请求的参数设置（可参考jQuery.ajax）
     * @param options.url {String} - 必填，服务路径
     * @param options.dataType {String} - 可选， 数据类型
     * @param options.context {Object} - 可选，回调的上下文
     * @param options.async {Boolean} - 可选，是否异步
     * @param options.data {Object} - 可选，请求的参数
     * @param options.showLoading {Boolean} - 可选，是否显示进度条；默认false,设置为true显示
     * @param {callback} callback - 请求完成的回调
     * @param context {Object} 可选，上下文
     * @param param {Object} - 可选，附加的参数，请求完成后作为参数返回给callback
     * @returns {XmlHttpRequest} 返回请求对象
     */
    util.ajaxGet = function(options, callback, context, param) {
        var opts = jQuery.extend({}, options);
        opts.type = 'get';
        opts.success = function(data, status, xhr) {
            if (options.showLoading) {
                util._showLoading(false);
            }
            util.isFunction(callback) && callback.call(context, data, status, xhr, param);
        }
        opts.error = function(xhr, status, msg) {
            if (options.showLoading) {
                util._showLoading(false);
            }
            console.error(options.url + " request failed!");
            util.isFunction(callback) && callback.call(context, null, status, xhr, param);
        }
        if (options.showLoading) {
            util._showLoading(true);
        }
        return jQuery.ajax(opts);
    }

    /**
     * 回调函数
     * @ignore
     * @callback  G.utils.CommonUtil~ajaxGetCallback
     * @param {Object} data 返回数据，如果请求出错，data=null
     * @param {number} status 状态信息
     * @param {XMLHttpRequest}  xhr 请求对象
     * @param {Object} param 附加参数
     */
    /**
     * ajax post请求
     * @ignore
     * @method
     * @param options {Object} - 必填，请求的参数设置（可参考jQuery.ajax）
     * @param options.url {String} - 必填，服务路径
     * @param options.dataType {String} - 可选， 数据类型
     * @param options.context {Object} - 可选，回调的上下文
     * @param options.async {Boolean} - 可选，是否异步
     * @param options.data {Object} - 可选，请求的参数
     * @param options.showLoading {Boolean} - 可选，是否显示进度条；默认false,设置为true显示
     * @param {callback} callback - 请求完成的回调
     * @param context {Object} 可选，上下文
     * @param param {Object} - 可选，附加的参数，请求完成后作为参数返回给callback
     * @returns {XmlHttpRequest} 返回请求对象
     */
    util.ajaxPost = function(options, callback, context, param) {

        var opts = jQuery.extend({}, options);

        opts.type = 'post';
        opts.success = function(data, status, xhr) {
            util.isFunction(callback) && callback.call(context, data, status, xhr, param);
            if (options.showLoading) {
                util._showLoading(false);
            }
        }
        opts.error = function(xhr, status, msg) {
            util.isFunction(callback) && callback.call(context, null, status, xhr, param);
            if (options.showLoading) {
                util._showLoading(false);
            }
        }
        if (options.showLoading) {
            util._showLoading(true);
        }
        return jQuery.ajax(opts);
    }

    /**
     * 回调函数
     * @ignore
     * @callback  G.utils.CommonUtil~ajaxPostCallback
     * @param {Object} data 返回数据，如果请求出错，data=null
     * @param {number} status 状态信息
     * @param {XMLHttpRequest} xhr 请求对象
     * @param {Object} param 附加参数
     */
    /**
     * 取消ajax请求
     * @ignore
     * @method
     * @param xhr {Object} - XMLHttpRequest对象
     */
    util.cancelRequest = function(xhr) {
        if (xhr instanceof XMLHttpRequest) {
            if (xhr.readyState != 4) {
                try {
                    xhr.abort();
                } catch (e) {}
            }
        }
    }

    /**
     * 获取配置,同步方式
     * @method
     * @ignore
     * @param options {Object} 必填
     * @param options.url {String} 必填，路径
     */
    util.getConfig = function(options) {
        var _cfg, options = options || {};
        util.ajaxGet({
            url: options.url,
            dataType: 'json',
            async: false
        }, function(cfg) {
            _cfg = cfg || {};
        });
        return _cfg;
    }

    // 对Date的扩展，将 Date 转化为指定格式的String
    // 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
    // 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
    // 例子：
    // (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
    // (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
    /**
     * 将 Date 转化为指定格式的String
     * @method
     * @param fmt {string} - 格式化模板字符串，月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
     * @returns {string} - 指定格式的日期字符串
     */
    Date.prototype.format = function(fmt) {
        var o = {
            "M+": this.getMonth() + 1, //月份
            "d+": this.getDate(), //日
            "h+": this.getHours(), //小时
            "m+": this.getMinutes(), //分
            "s+": this.getSeconds(), //秒
            "q+": Math.floor((this.getMonth() + 3) / 3), //季度
            "S": this.getMilliseconds() //毫秒
        };
        if (/(y+)/.test(fmt))
            fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o)
            if (new RegExp("(" + k + ")").test(fmt))
                fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        return fmt;
    }

    /**
     * 判断值value是否在rangeStr范围内
     * @ignore
     * @method
     * @param value {String} - 必填，判断的值
     * @param rangeStr {String/RegExp} - 必填，值域的字符串或者正则表达式；如：1,[1],[0,2],(0,2],(2,),(,0),[0,2);
     * 传单值(1/[1])表示==,如rangeStr=1，等价于[1,1],即<=1&&>=1;
     * []表示闭区间>= & <=,()表示开区间> & <;
     * (0,)表示>0;[,2]表示<=2;[0,2)表示>=0且<2;
     * //
     * 如果rangeStr是正则；则使用正则匹配；
     * 如果rangeStr是※分割的，则代表复合值；如如果rangeStr是='123※null';当value=123或者为空值时返回true;
     * @returns {Boolean}
     */
    util.assertWithin = function(value, rangeStr) {
        //1大类情形判定处理；3小类
        function doFristCase(value, rangeStr) {
            //1.1 rangeStr=undefined
            var rangeStrKey = (rangeStr == undefined); //
            if (rangeStrKey) {
                return false;
            } //排除undefined,null
            //1.2 rangeStr如果是正则对象
            if (rangeStr instanceof RegExp) {
                return rangeStr.test(value);
            }
            // rangeStr非null，value为undefined,null,'' ,
            function getTwoNullFlag(value, rangeStr) {
                return ((rangeStr.toLowerCase() == 'null') && (value == undefined || value == ''))
            }

            //1.3处理空值
            if (getTwoNullFlag(value, rangeStr)) {
                return true;
            }
        };
        var fristCase = doFristCase(value, rangeStr);
        if (fristCase != undefined) {
            return fristCase
        };

        //2.1 处理复合值，迭代调用
        var seperator = '※';
        var complexFlag = (rangeStr.indexOf(seperator) >= 0);

        function doCompleValue(rangeStr, value, seperator) {
            var array = rangeStr.split(seperator);
            for (var i = 0, len = array.length; i < len; i++) {
                var ranStr = array[i];
                if (ranStr) {
                    if (util.assertWithin(value, ranStr)) {
                        return true;
                    }
                }
            }
            return false;
        }

        if (complexFlag) {
            return doCompleValue(rangeStr, value, seperator);
        }

        //第二大类情形，3小类
        function doSecondCase(value, rangStr) {
            //2.2 处理非复合值;区间判定false
            rangeStr = rangeStr.trim();
            var regionFlag = /[\[\(\)\]].*/i.test(rangeStr);
            if (regionFlag == false) {
                return value == rangeStr;
            }

            //2.3 区间true + value非数值
            value = parseFloat(value);
            if (isNaN(value)) {
                return false;
            }

            //2.4 区间true + vaule数值
            var str = rangeStr.replace(/[\[\]\(\)]/g, '');
            var arr = str.split(',');
            //[2]     2.4区间true+  only one value
            if (arr.length == 1) {
                return value == parseFloat(arr[0]);
            };

        };
        var secondCase = doSecondCase(value, rangeStr);
        if (secondCase != undefined) {
            return secondCase
        };

        //第三大类情形，有极大值和极小值开闭区间情形
        function doRegionCase(value, rangeStr) {
            //
            rangeStr && (rangeStr = rangeStr.trim());
            if (!/[\[\(\)\]].*/i.test(rangeStr)) {
                return value == rangeStr;
            }
            value = parseFloat(value);
            if (isNaN(value)) {
                return false;
            }
            //
            var str = rangeStr.replace(/[\[\]\(\)]/g, '');
            var arr = str.split(',');
            //[2]
            if (arr.length == 1) {
                return value == parseFloat(arr[0]);
            }
            var floor = parseFloat(arr[0]),
                celling = parseFloat(arr[1]);
            var handleObjs = [
                function(value, rangeStr) {
                    if (!isNaN(floor) && isNaN(celling)) {
                        if (rangeStr.startsWith('[')) {
                            return value >= floor;
                        }
                        if (rangeStr.startsWith('(')) {
                            return value > floor;
                        }
                    }
                    return undefined;
                },
                function(value, rangeStr) {
                    if (isNaN(floor) && !isNaN(celling)) {
                        if (rangeStr.endsWith(']')) {
                            return value <= celling;
                        }
                        if (rangeStr.endsWith(')')) {
                            return value < celling;
                        }
                    }
                    return undefined;
                },
                function(value, rangeStr) {
                    var flag = true;
                    //minvalue
                    if (rangeStr.startsWith('[')) {
                        flag = flag && (value >= floor);
                    } else if (rangeStr.startsWith('(')) {
                        flag = flag && (value > floor);
                    }
                    if (!flag) {
                        return false;
                    }
                    //maxvalue
                    if (rangeStr.endsWith(']')) {
                        flag = flag && (value <= celling);
                    } else if (rangeStr.endsWith(')')) {
                        flag = flag && (value < celling);
                    }
                    return flag;
                }
            ]
            var returnVal = undefined;
            for (var k = 0, len = handleObjs.length; k < len; k++) {
                returnVal = handleObjs[k](value, rangeStr);
                if (returnVal != undefined) {
                    break;
                }
            }
            return returnVal;
        };
        var regionCase = doRegionCase(value, rangeStr);
        if (regionCase != undefined) {
            return regionCase
        };
        return false;
    }

    /**
     * 返回数值最接近的整数
     * @ignore
     * @method
     * @param val {string|number} 值
     * @param unit 单位
     * @param minNum 最小返回值
     * @returns {*|number}
     */
    util.getEquivalentNum = function(val, unit, minNum) {
        var v = parseInt(val),
            minNum = minNum || 10,
            munit = unit,
            num = minNum;
        if (isNaN(v)) {
            return num;
        }
        var str = v + '',
            len = str.length,
            v1 = v,
            v2;
        num = (len - 1) * unit;
        for (var i = 0; i < len; i++) {
            var n = parseInt(str[i]);
            munit = munit / 10;
            num += n * munit;
        }
        if (num < minNum) {
            num = minNum;
        }
        return Math.round(num);
    }


    /**
     * 根据值的路径(从window下寻取)获取值（等同eval效果）；如 根据 字符串'G.util.CommonUtil'获取对应的变量;
     * @method
     * @ignore
     * @param varPath {string} - 路径
     * @return val {object} - 对应变量
     */
    util.getValByVarPath = function(varPath) {
        var val = null;
        if (varPath) {
            var arr = varPath.split('.');
            var curObj = window;
            for (var i = 0, len = arr.length; i < len; i++) {
                var path = arr[i];
                if (path === 'window') {
                    continue;
                }
                if (!curObj) {
                    break;
                }

                curObj = curObj[path];
            }
            val = curObj;
        }
        return val;
    }

    //对象标识
    util.lastId = 0;
    /**
     * 生成对象唯一标识
     * @alias stamp
     * @memberof G.utils.CommonUtil
     * @param obj {Object} 必填，需要生成唯一标识的对象
     * @returns {*|number} 返回唯一标识
     */
    util.stamp = function(obj) {
        if (obj instanceof Object) {
            obj._unique_id = obj._unique_id || (++this.lastId);
            return obj._unique_id;
        }
        return NaN;
    }

    /**
     * 产生一个新的随机ID
     * @alias newUUID
     * @memberof G.utils.CommonUtil
     * @returns {String} 返回ID字符串
     */
    util.newUUID = function() {
        var g = function() {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        }
        return (g() + g() + "-" + g() + "-" + g() + "-" + g() + "-" + g() + g() + g());
    }

    /**
     * 获取32位随机id
     * @alias newUUID32
     * @memberof G.utils.CommonUtil
     * @returns {string} 返回不带-的唯一标识
     */
    util.newUUID32 = function() {
        var uuid = this.newUUID();
        return uuid.replace(/-/g, '');
    }

    /**
     * 替换占位符
     * @alias replacePlaceHolder
     * @memberof G.utils.CommonUtil
     * @param data {Object} 持有属性的对象
     * @param textFormat {String} 需要替换占位符的字符串
     * @returns {*} 返回文本
     */
    util.replacePlaceHolder = function(data, textFormat) {
        if (!textFormat) {
            return '';
        }
        var phReg = /(\$\{[\w\_\-\d]{0,}\})/g,
            attrReg = /([\w\_\-\d]+)/g;
        var phArr = textFormat.match(phReg),
            text = textFormat;
        if (phArr && phArr.length > 0) {
            for (var i = 0, len = phArr.length; i < len; i++) {
                var placeHolder = phArr[i],
                    replace = '';
                var attrArr = placeHolder.match(attrReg);
                if (attrArr && attrArr.length == 1) {
                    replace = data[attrArr[0]] || '';
                }
                text = text.replace(placeHolder, replace);
            }
        }
        return text;
    }

    /**
     *浏览器类型判断
     * @ignore
     * @method
     * @reorturns {object} -{{ie: boolean, ielt9: boolean, webkit: boolean, gecko: boolean, android: boolean,android23: boolean, chrome: boolean, ie3d: boolean, webkit3d: boolean, gecko3d: boolean, opera3d: boolean, any3d: boolean, mobile: boolean, mobileWebkit: boolean, mobileWebkit3d: boolean, mobileOpera: boolean, touch: (boolean|*), msPointer: (boolean|*), pointer: (*|boolean), retina: (boolean|MediaQueryList)}}
     */
    util.Browser = function() {
        function getKeyCheck(str, key) {
            return str.indexOf(key) !== -1
        };

        function getMobileCheck() {
            return typeof orientation !== undefined + '';
        };

        function getMsPointerCheck() {
            return !window.PointerEvent && window.MSPointerEvent;
        };

        function getPointCheck(msPointer) {
            return (window.PointerEvent && window.navigator.pointerEnabled) || msPointer;
        };

        function getRetinaCheck() {
            return ('devicePixelRatio' in window && window.devicePixelRatio > 1) ||
                ('matchMedia' in window && window.matchMedia('(min-resolution:144dpi)') &&
                    window.matchMedia('(min-resolution:144dpi)').matches)
        };

        function getIeCheck() {
            return 'ActiveXObject' in window
        };

        function getIelt9Check(ie) {
            return ie && !document.addEventListener
        };

        function getIe3d(ie, doc) {
            return ie && ('transition' in doc.style)
        };

        function getWebkit3d(android23) {
            return ('WebKitCSSMatrix' in window) &&
                ('m11' in new window.WebKitCSSMatrix()) && !android23
        };

        function getAny3d(complex) {
            return !window.L_DISABLE_3D && (complex[0] ||
                complex[1] || complex[2] || complex[3]) && !complex[4]
        };

        function getTouch(phantomjs, pointer) {
            return !window.L_NO_TOUCH && !phantomjs && (pointer || 'ontouchstart' in window ||
                (window.DocumentTouch && document instanceof window.DocumentTouch))
        };

        var ie = getIeCheck(),
            ielt9 = getIelt9Check(ie),
            ua = navigator.userAgent.toLowerCase(),
            webkit = getKeyCheck(ua, 'webkit'),
            chrome = getKeyCheck(ua, 'chrome'),
            phantomjs = getKeyCheck(ua, 'phantom'),
            android = getKeyCheck(ua, 'android'),
            android23 = getKeyCheck(ua, 'android [23]'),
            gecko = getKeyCheck(ua, 'gecko'),
            mobile = getMobileCheck(),
            msPointer = getMsPointerCheck(),
            pointer = getPointCheck(msPointer),
            retina = getRetinaCheck(),
            doc = document.documentElement,
            ie3d = getIe3d(ie, doc),
            webkit3d = getWebkit3d(android23),
            gecko3d = 'MozPerspective' in doc.style,
            opera3d = 'OTransition' in doc.style,
            any3d = getAny3d([ie3d, webkit3d, gecko3d, opera3d, phantomjs]);
        var touch = getTouch(phantomjs, pointer);

        return {
            ie: ie,
            ielt9: ielt9,
            webkit: webkit,
            gecko: gecko && !webkit && !window.opera && !ie,

            android: android,
            android23: android23,
            chrome: chrome,
            ie3d: ie3d,
            webkit3d: webkit3d,
            gecko3d: gecko3d,
            opera3d: opera3d,
            any3d: any3d,
            mobile: mobile,
            mobileWebkit: mobile && webkit,
            mobileWebkit3d: mobile && webkit3d,
            mobileOpera: mobile && window.opera,
            touch: touch,
            msPointer: msPointer,
            pointer: pointer,
            retina: retina
        };
    }
    return util;
});